import { useStore } from '@/store';
import { defineComponent, onMounted, reactive } from '@vue/composition-api';

type ChildMenu = Omit<Menu, 'children' | 'isActive'> & {
  isFocus: boolean;
  to?: string;
  target?: string;
};

type Menu = {
  text: string;
  icon: string;
  isActive: boolean;
  isAllow?: boolean;
  link?: string;
  children?: ChildMenu[];
};

// リアクティブな変数の型定義
export type ReactiveData = {
  isOpen: boolean;
  mainTitle: string;
  menus: Menu[];
  list: boolean;
  isSizeOver: boolean;
};

const userMenus = [
  {
    text: '合格発表管理',
    icon: 'mdi-file-document',
    isActive: false,
    isAllow: true,
    children: [
      {
        text: 'リハーサル準備',
        icon: 'mdi-upload',
        isAllow: true,
        to: '/user/result-publication/rehearsal',
        isFocus: false,
      },
      {
        text: '本番準備',
        icon: 'mdi-upload',
        isAllow: true,
        to: '/user/result-publication/live',
        isFocus: false,
      },
    ],
  },
  {
    text: '周知文書',
    icon: 'mdi-file-document',
    isActive: false,
    isAllow: true,
    children: [
      {
        text: '受検者への周知文書',
        icon: 'mdi-download',
        isAllow: true,
        to: '/user/official-documents/download',
        isFocus: false,
      },
    ],
  },
];

/**
 * 共通画面コンポーネント
 *
 * ヘッダ/サイドメニュー/各機能(router-outlet)の基盤となる
 */
export default defineComponent({
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    onOpen: {
      type: Function,
    },
  },
  setup({ isOpen, onOpen }) {
    const store = useStore();

    const state = reactive<ReactiveData>({
      isOpen: true,
      mainTitle: '',
      list: false,
      menus: [],
      isSizeOver: false, // ログインユーザー名が超過したか
    });

    onMounted(() => {
      const pathname = window.location.pathname;

      const accessesUrl = store.getters.validation.google_analytics_url;

      const adminMenus = [
        {
          text: '合格発表管理',
          icon: 'mdi-file-document',
          isActive: false,
          isAllow: true,
          children: [
            {
              text: '学校一覧',
              icon: 'mdi-school',
              isAllow: true,
              to: '/admin/result-publication/schools',
              isFocus: false,
            },
            {
              text: '対応状況',
              icon: 'mdi-database-search',
              isAllow: true,
              to: '/admin/result-publication/statuses',
              isFocus: false,
            },
            {
              text: 'アクセス状況',
              icon: 'mdi-chart-bar',
              isAllow: true,
              link: accessesUrl,
              isFocus: false,
              target: '_blank',
            },
            {
              text: '公開情報リセット',
              icon: 'mdi-eraser',
              isAllow: true,
              to: '/admin/result-publication/reset',
              isFocus: false,
            },
            {
              text: '管理者一覧',
              icon: 'mdi-account-cog',
              isAllow: true,
              to: '/admin/result-publication/admin-schools',
              isFocus: false,
            },
          ],
        },
        {
          text: '周知文書登録',
          icon: 'mdi-file-document',
          isActive: false,
          isAllow: true,
          children: [
            {
              text: '県立中学・中等教育学校',
              icon: 'mdi-upload',
              isAllow: true,
              to: '/admin/official-documents/junior-high-school',
              isFocus: false,
            },
            {
              text: '県立高等学校',
              icon: 'mdi-upload',
              isAllow: true,
              to: '/admin/official-documents/senior-high-school',
              isFocus: false,
            },
          ],
        },
      ];

      if (pathname.includes('admin')) {
        state.menus = adminMenus;
      } else {
        state.menus = userMenus;
      }
    });

    /**
     * 子メニュー表示項目変更
     */
    const menuDisplay = (menuChildren: ChildMenu[]) => {
      // 子メニューのisAllow が false 以外の場合(未設定 or true)は表示する項目に加える
      return menuChildren.filter((menu) => menu.isAllow !== false);
    };

    return {
      state,
      isOpen,
      onOpen,
      menuDisplay,
    };
  },
});
